import classNames from 'classnames';
import PropTypes from 'prop-types';

const SearchIcon = ({ className, width = '16' }) => {
  return (
    <svg
      className={classNames('search-icon', className)}
      width={width}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        stroke='currentColor'
        strokeWidth='1.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M14.75 14.75L12.1251 12.125M14 7.625C14 11.1458 11.1458 14 7.625 14C4.10418 14 1.25 11.1458 1.25 7.625C1.25 4.10418 4.10418 1.25 7.625 1.25C11.1458 1.25 14 4.10418 14 7.625Z'
      />
    </svg>
  );
};

SearchIcon.propTypes = {
  className: PropTypes.string,
};

export default SearchIcon;
